import { useQuery } from '@tanstack/react-query';

import { type OperatingUnitOption, listOperatingUnitOptions } from './operating-units-api';

/**
 * Same options as `useOperatingUnitOptions`, plus whether the first answer is still pending — for
 * screens that must not fire a unit-scoped request before they know how many units there are.
 */
export function useOperatingUnitOptionsState(): {
  options: OperatingUnitOption[];
  isPending: boolean;
} {
  const query = useQuery({
    queryKey: ['operating-unit-options'],
    queryFn: listOperatingUnitOptions,
  });

  return { options: Array.isArray(query.data) ? query.data : [], isPending: query.isPending };
}

/**
 * Active units within the caller's scope (`GET /operating-units/options`). Empty while loading
 * or when the request fails: every consumer treats "no options" as "nothing to choose".
 */
export function useOperatingUnitOptions(): OperatingUnitOption[] {
  return useOperatingUnitOptionsState().options;
}
